// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__39Bwh","colMaxWidth":"Table_colMaxWidth__ZoI1u"};